import axios from 'axios';

import { showNotification } from '@/lib/components/Notification';
import i18n from '@/lib/config/i18n';

export const PREVIOUS_PAYMENT_ABORTED_HEADER = 'x-lyria-previous-payment-aborted';
export const PREVIOUS_PAYMENT_ABORTED_MESSAGE_KEY = 'previous_payment_aborted';
export const ABORTED_PAYMENT_STATUS = 'A';

export const getPreviousPaymentErrorMessage = (previousStatus) => {
    const errorCode = previousStatus?.error;
    if (!errorCode) {
        return i18n.t(PREVIOUS_PAYMENT_ABORTED_MESSAGE_KEY);
    }
    return i18n.t([`error_${errorCode}`, errorCode, PREVIOUS_PAYMENT_ABORTED_MESSAGE_KEY]);
};

export const fetchPreviousPaymentStatus = async (lyriaUrl, paymentRequestId) => {
    const response = await axios.get(
        `${lyriaUrl}/payments/paymentrequests/${paymentRequestId}/get-previous-status/`,
    );
    return response.data;
};

export const handlePreviousPaymentAbortedIfNeeded = async ({
    response,
    lyriaUrl,
    paymentRequestId,
}) => {
    try {
        if (response?.headers?.[PREVIOUS_PAYMENT_ABORTED_HEADER] !== 'true') {
            return;
        }

        const previousStatus = await fetchPreviousPaymentStatus(lyriaUrl, paymentRequestId);
        if (previousStatus?.status !== ABORTED_PAYMENT_STATUS) {
            return;
        }
        showNotification(getPreviousPaymentErrorMessage(previousStatus));
    } catch (error) {
        console.error(error);
    }
};
